import { Box } from '../../mui';
import { darkModeColors } from '../../theme/theme';

export const WaveSvgD =
  'M0 27.6055C257.437 93.5919 487.049 112.457 653.859 112.457C917.312 112.457 1180.27 79.0256 1440 0V548H0L0 27.6055Z';

const FooterWave = () => {
  return (
    <Box
      sx={{
        mb: -1,
        display: 'block',
        minWidth: '100%',
        overflow: 'hidden',
      }}
    >
      <svg
        viewBox='0 0 1440 120'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0 27.6055C257.437 93.5919 487.049 112.457 653.859 112.457C917.312 112.457 1180.27 79.0256 1440 0V548H0L0 27.6055Z'
          fill={darkModeColors.background.default}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0 27.6055C257.437 93.5919 487.049 112.457 653.859 112.457C917.312 112.457 1180.27 79.0256 1440 0V548H0L0 27.6055Z'
          fill={darkModeColors.primary.dark}
        />
      </svg>
    </Box>
  );
};

export default FooterWave;
